import { ClientPathSchema } from '@/features/dashboard/client/clientSchema'
import { IdentityEditPage } from '@/features/dashboard/client/detail/identity-edit/IdentityEditPage'
import { usePageTitle } from '@/hooks/usePageTitle'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { IdentityEditReturnTo } from '@/features/dashboard/client/identity/identityEnum'
import { IdentitySearchSchema } from '@/features/dashboard/client/identity/identitySchema'

// 本人確認情報編集画面の検索パラメータ
// IdentitySearchSchemaにreturnToを追加
const IdentityEditSearchSchema = IdentitySearchSchema.extend({
  returnTo: z.enum(Object.values(IdentityEditReturnTo)).optional(),
});

export const Route = createFileRoute('/_dashboard/clients/$clientId/identity/edit')({
  component: RouteComponent,
  parseParams: ClientPathSchema.parse,
  validateSearch: IdentityEditSearchSchema,
})

function RouteComponent() {
  usePageTitle('本人確認情報編集')
  return <IdentityEditPage />
}
